import { Outlet } from 'react-router-dom'
import { Footer } from './Footer'
import { Header } from '../navigation/Header'

export function SiteLayout() {
  return <><Header /><main><Outlet /></main><Footer /></>
}
